/**
 * МЕРЦАНИЕ ОТМЕТКИ ПРОПУСКА ХОДА «zzZ» над отрядом (change unit-auto-selection,
 * HexGridRenderer.addUnitSkipMark) — в такт покачиванию отряда: в верхней
 * точке все буквы видны целиком, в нижней — все прозрачны. Пока значок
 * поднимается, буквы проявляются от маленькой к большой, пока опускается —
 * гаснут в том же порядке, от маленькой к большой.
 *
 * Прозрачность считается не от времени, а от того, насколько значок поднят
 * (его качает твин с тем же темпом и характером, что и отряд), поэтому мерцание
 * совпадает с качанием и по фазе, и по сглаживанию — и начинается заново
 * вместе с ним, когда поле перерисовывается
 */
export const UNIT_SKIP_MARK_BLINK = Object.freeze({
  // Какую долю подъема проявляется (и какую долю спуска гаснет) одна буква.
  // Соседние буквы перекрываются: последняя заканчивает ровно в верхней точке
  letterLiftSpan: 0.6,
});
